<template>
    <div class="l-propertylisting">
        <div class="container">
            <div class="tabbed-list" id="propertylisting-tabs" role="tablist">
                <a 
                    v-for="tab in tabs"
                    :key="tab.id"
                    :class="['tabbed-list__tab', { 'tabbed-list__tab--active': activeTab === tab.id }]"  
                    :id="tab.slotName + 'Tab'" 
                    data-toggle="tab" 
                    :href="'#' + tab.label + 'Tab'" 
                    role="tab" 
                    @click.prevent="setActiveTab(tab.id)" 
                    :aria-controls="tab.slotName + '-tab-panel'" 
                    :aria-selected="activeTab === tab.id ? 'true' : 'false'">
                    {{ tab.label }}
                </a>
                <a 
                    v-if="mapViewUrl" 
                    class="tabbed-list__tab" 
                    id="mapTab" 
                    :href="mapViewUrl + '?' + filterQuerystring"
                    role="tab">
                    Map view
                </a>
            </div>
        </div>
        <div 
            v-for="tab in tabs"
            :key="tab.id + '-panel'"
            :class="['tabbed-list__panel', { 'tabbed-list__panel--active': activeTab === tab.id }]"
            :id="tab.slotName + '-tab-panel'"
            role="tabpanel"
            :aria-labelledby="tab.slotName + '-tab'"
            v-show="activeTab === tab.id">
            
            <regions-list v-if="tab.slotName === 'locations'"></regions-list>
            <properties-list v-if="tab.slotName === 'list'"></properties-list>
        </div>
    </div>

</template>

<script>
    // import $ from 'jquery'
    import PropertiesList from '@/components/SiteSearch/search-list'
    import RegionsList from '@/components/PropertySearch/regions-list'

    import { globalMixin } from '@/mixins/globalMixin.js'

    export default {
        components: {
            PropertiesList,
            RegionsList
        },

        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },

            currentTab: {
                get() {
                    return this.$store.state.propertiesSearch.currentTab
                },
                set(newValue) {
                    this.$store.dispatch('updatePropertiesSearchCurrentTab', newValue)
                }
            },

            filterQuerystring: function () {
                return this.$store.getters.searchFiltersQuerystring()
            },

            hasFilter: function () {
                return this.$store.state.search.hasFilter
            },

            isLoggedIn: function () {
                return isLoggedIn
            }
        },

        created: function () {
            this.activeTab = this.tabs[0].id,
            this.$eventHub.$on('search-regionSelected', this.OnRegionSelected)
        },

        data() {
            return {
                loading: false,
                activeTab: null,
                tabs: [
                    {
                        id: 'regions-list',
                        label: 'Locations',
                        slotName: 'locations'
                    },
                    {
                        id: 'properties-list',
                        label: 'List view',
                        slotName: 'list'
                    }
                ]
            }
        },

        methods: {
            setActiveTab(tabId) {
                this.activeTab = tabId
            },

            OnRegionSelected: function () {
                this.currentTab = 'list-tab-panel'
                this.activeTab = 'properties-list'
            }
        },

        mixins: [globalMixin],

        props: {
            mapViewUrl: String
        }
    }
</script>